import { gql } from 'apollo-angular';
import { File } from '../../entities/file/file';
import { Page } from '../../entities/page/page';


export const GET_FILES_PAGED_QUERY = gql`
query getFilesPaged(
  $ownerId: UUID,
  $ownerType: String,
  $role: String,
  $pageNumber: Int,
  $pageSize: Int
){
  filesPage: getFilesPaged(
    filter: {
      ownerId: $ownerId,
      ownerType: $ownerType,
      role: $role,
      sortRequest: { sortProperties: ["id"], sortDirection: "asc" },
      pagination: { number: $pageNumber, size: $pageSize,  sortProperty: "id", sortDirection: "asc"}
    }
  ){
      totalPages
      totalElements
      number
      size
      content{
        id
        fileName
        fullPath
        uploadedDateTime
        extension
        size
        createdBy {
          id
          firstName
          lastName
        }
        createdDateTime
        fileOwners {
          ownerId
          ownerType
          ownerLabel
        }
      }
  }
}
`;

export interface GetFilesPagesVariables {
  ownerId: any;
  ownerType?: string;
  role?: string;
  pageNumber?: number;
  pageSize?: number;
}

export interface GetFilesPagedResponse {
  filesPage: Page<File>;
  loading: boolean;
}

export const GET_FILES_QUERY = gql`
query getFiles(
  $ownerId: UUID,
  $role: String
){
  files: getFiles(
    filter: {
      ownerId: $ownerId,
      role: $role
    }
  ){
    id
    fileName
    fullPath
    uploadedDateTime
    extension
    size
  }
}
`;

export interface GetFilesVariables {
  ownerId: any;
  role?: string
}

export interface GetFilesResponse {
  files: File[];
  loading: boolean;
}

export const DELETE_FILE_MUTATION = gql`
mutation deleteFile($id: UUID) {
  deleteFile(id: $id)
}
`;

export const CREATE_FILES_MUTATION = gql`
mutation createFiles($fileInputs: [FileInput]) {
  createFiles(fileInputs: $fileInputs) {
    id
    fileName
    fullPath
    uploadedDateTime
    extension
    size
    state
  }
}
`;

export interface FileInputDto {
  id: string;
  fileName: string;
  batchId: string;
  owners: FileOwnerInputDto[];
}

export interface FileOwnerInputDto {
  ownerId: string;
  ownerType?: string;
  role?: string;
}

export interface CreateFilesVariables {
  fileInputs: FileInputDto[];
}

export interface CreateFilesResponse {
  createFiles: File[];
  loading: boolean;
}
